import { System } from '../core/index.js';
import { getMoveTable } from '../combat/index.js';
import { AnimationRegistry } from './profiles.js';
import { stateMotionCoverage, stateMotionFor } from './state-motion.js';
import { throwMotionCoverage, throwMotionFor } from './throw-motion.js';

/** Owns the immutable move-animation registry consumed by the procedural fighter presentation. */
export class AnimationSystem extends System {
  static id = 'animation';
  static deps = ['combat-sim'];
  static budgetMs = 0;

  constructor() {
    super();
    this.registry = null;
    this.moves = null;
  }

  async init(ctx) {
    this.moves = getMoveTable().all;
    this.registry = new AnimationRegistry(this.moves);
    const coverage = this.registry.coverage(this.moves);
    const stateCoverage = stateMotionCoverage();
    const throwCoverage = throwMotionCoverage(this.moves);
    if (!coverage.complete) {
      throw new Error(`animation: ${coverage.missing.length} move animation(s) are unresolved.`);
    }
    if (!stateCoverage.complete) {
      throw new Error(`animation: ${stateCoverage.missing.length} fighter state motion(s) are unresolved.`);
    }
    if (!throwCoverage.complete) {
      throw new Error(`animation: ${throwCoverage.missing.length} paired throw motion(s) are unresolved.`);
    }
    ctx.data.animations = this.registry;
    ctx.metrics.setCounter('animation.profiles', coverage.profiles);
    ctx.metrics.setCounter('animation.stateProfiles', stateCoverage.profiles);
    ctx.metrics.setCounter('animation.throwProfiles', throwCoverage.profiles);
    ctx.log.info(
      `animation: ${coverage.profiles}/${coverage.moves} move ids covered across ` +
      `${Object.keys(coverage.families).length} motion families; ` +
      `${stateCoverage.states}/${stateCoverage.states} fighter states resolved; ` +
      `${throwCoverage.throws}/${throwCoverage.throws} paired throws resolved`,
    );
  }

  profile(id) {
    if (!this.registry) throw new Error('animation: registry is not ready.');
    return this.registry.get(id);
  }

  stateProfile(fighter) {
    return stateMotionFor(fighter);
  }

  throwProfile(moveId) {
    return throwMotionFor(moveId);
  }

  coverage() {
    return this.registry ? this.registry.coverage(this.moves) : null;
  }

  dispose() {
    this.registry = null;
    this.moves = null;
  }
}
